import { render, staticRenderFns } from "./ProjectLoader.vue?vue&type=template&id=3d90d770&scoped=true&"
import script from "./ProjectLoader.vue?vue&type=script&lang=js&"
export * from "./ProjectLoader.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLoader.vue?vue&type=style&index=0&id=3d90d770&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90d770",
  null
  
)

export default component.exports